module.exports = "/_next/static/images/integrate-citation-generator-9aa206f029c56383dcd922b0e39e4cca.png";